var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6278 4.37222C19.3894 4.13389 19.0661 4 18.729 4C18.3919 4 18.0686 4.13389 17.8302 4.37222L12 10.2024L6.16983 4.37222C5.93143 4.13389 5.60813 4 5.27103 4C4.93392 4 4.61062 4.13389 4.37222 4.37222C4.13389 4.61062 4 4.93392 4 5.27103C4 5.60813 4.13389 5.93143 4.37222 6.16983L10.2024 12L4.37222 17.8302C4.13389 18.0686 4 18.3919 4 18.729C4 19.0661 4.13389 19.3894 4.37222 19.6278C4.61062 19.8661 4.93392 20 5.27103 20C5.60813 20 5.93143 19.8661 6.16983 19.6278L12 13.7976L17.8302 19.6278C18.0686 19.8661 18.3919 20 18.729 20C19.0661 20 19.3894 19.8661 19.6278 19.6278C19.8661 19.3894 20 19.0661 20 18.729C20 18.3919 19.8661 18.0686 19.6278 17.8302L13.7976 12L19.6278 6.16983C19.8661 5.93143 20 5.60813 20 5.27103C20 4.93392 19.8661 4.61062 19.6278 4.37222Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c19449061837a374b31f2a43bba2a3d5.svg";
export { ForwardRef as ReactComponent };